// ExerciseComponent.js
import React from "react";
import { useHistory, useLocation } from "react-router-dom";

const ExerciseComponent = ({ item, index }) => {
  const history = useHistory();
  const location = useLocation();
const handleClick = (e) => {
  e.preventDefault();

  const cleanName = item.title
    .replace(/\s+/g, "")
    .replace(/[^a-zA-Z0-9]/g, "");

  history.push({
    pathname: location.pathname,
    search: `?${cleanName}`, // 👈 no "="
  });
};

  return (
    <div className={`col-lg-3 col-6 p-2 fade-in-bottom delay${index}s`}>
      <div className="shadow position-relative rounded border bugbountycontent">
        <img
          src={item.image_url}
          className="img-responsive rounded-bottom-0 w-100 rounded"
          alt={item.title}
        />
        <div className="p-2 text-dark text-center text-decoration-none">
          <h4 className="text-light truncate truncate2 sm-16">{item.title}</h4>
          <p className="truncate truncate-3 truncate3 sm-12">
            {item.description}
          </p>
          <div className="d-flex justify-content-center mt-2 mb-2">
            <button
              className="btn btn-primary sm-10 truncate truncate1 rounded btn-sm rounded-pill pb-2"
              onClick={handleClick}
            >
              Let's Inject Some Code
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExerciseComponent;
